"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddLiquidityRecipe = void 0;
const utils_1 = require("../../utils");
const recipe_1 = require("../recipe");
const cookbook_debug_1 = require("../../utils/cookbook-debug");
class AddLiquidityRecipe extends recipe_1.Recipe {
    addLiquidityData;
    getExpectedLPAmountFromRecipeOutput(recipeOutput) {
        try {
            if (!recipeOutput) {
                return undefined;
            }
            if (!this.addLiquidityData) {
                return undefined;
            }
            const { erc20AmountA, erc20AmountB, expectedLPAmount } = this.addLiquidityData;
            const unshieldStepOutput = recipeOutput.stepOutputs[0];
            const unshieldFeeA = unshieldStepOutput.feeERC20AmountRecipients?.find(fee => {
                return (0, utils_1.compareERC20Info)(fee, erc20AmountA);
            });
            if (!unshieldFeeA) {
                throw new Error('Expected one unshield fee to match token A.');
            }
            const unshieldFeeB = unshieldStepOutput.feeERC20AmountRecipients?.find(fee => {
                return (0, utils_1.compareERC20Info)(fee, erc20AmountB);
            });
            if (!unshieldFeeB) {
                throw new Error('Expected one unshield fee to match token B.');
            }
            const shieldStepOutput = recipeOutput.stepOutputs[recipeOutput.stepOutputs.length - 1];
            const shieldFee = shieldStepOutput.feeERC20AmountRecipients?.find(fee => {
                return (0, utils_1.compareERC20Info)(fee, expectedLPAmount);
            });
            if (!shieldFee) {
                throw new Error('Expected shield fee to match LP token.');
            }
            const output = shieldStepOutput.outputERC20Amounts.find(outputAmount => {
                return (0, utils_1.compareERC20Info)(outputAmount, expectedLPAmount);
            });
            if (!output) {
                throw new Error('Expected output to match LP token.');
            }
            return {
                aUnshieldFee: unshieldFeeA.amount,
                bUnshieldFee: unshieldFeeB.amount,
                lpAmount: output.expectedBalance,
                lpMinimum: output.minBalance,
                lpShieldFee: shieldFee.amount,
            };
        }
        catch (cause) {
            if (!(cause instanceof Error)) {
                throw new Error('Unexpected non-error thrown', { cause });
            }
            cookbook_debug_1.CookbookDebug.error(cause);
            return undefined;
        }
    }
}
exports.AddLiquidityRecipe = AddLiquidityRecipe;
